<template>
 <div class="container-fluid"  style="background-color: #F3F3F3" >
    <div class="container is-fluid banner-section bg-img">
      <p class="pb-banner-title">
        CONTACT US
      </p>
      <span class="yellow-line"></span>
    </div>
    <div class="section-top">
      <p class="pb-title" style=" font-weight: 700; line-height: 45px; color: #2B2D47; !important;">
        LET'S CONNECT
      </p>
      <p class="desc" style="cfont-weight: 400 !important; olor: #2B2D47;">
        Please fill in the form below and click the "Submit Inquiry" button to proceed. We will contact you within a week.
      </p>
    </div>
    <div class="contact-column bg-white">
      <div class="columns has-text-left mx-0">
        <div class="column is-three-quarters mx-auto">
          <validation-observer v-slot="{ handleSubmit, invalid }">
            <validation-provider :rules="{required: true, alpha_spaces: true, minName: 3}" v-slot="{ errors }">
              <b-field horizontal class="mb-5" label="Full Name" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <b-input v-model="inputFullName" placeholder="Enter your Full Name"></b-input>
              </b-field>
            </validation-provider>

            <validation-provider :rules="{required: true, email: true}" v-slot="{ errors }">
              <b-field horizontal label="Email Address" class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <b-input type="text" v-model="inputEmail" placeholder="Enter your Email Address"></b-input>
              </b-field>
            </validation-provider>

            <validation-provider :rules="{required: true, integer: true, minPhone: 10, maxPhone: 11}" v-slot="{ errors }">
              <b-field horizontal label="Contact No." class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                  <b-input v-model="inputPhoneNo" placeholder="Enter your Contact Number" style="max-height: 40px;"></b-input>
              </b-field>
            </validation-provider>

            <validation-provider :rules="{required: true}" v-slot="{ errors }">
              <b-field horizontal label="Region" class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <b-select placeholder="Select your Region" v-model="inputRegion">
                    <option style="color: #7A7A7A !important" value="" disabled selected>Select your Region</option>
                    <option
                        v-for="option in region"
                        :value="option.value"
                        :key="option.id">
                        
                        {{ option.value}}
                    </option>
                </b-select>
              </b-field>
            </validation-provider>

            <div class="purpose">
              <validation-provider  :rules="{required: true}" v-slot="{ errors }">
                <b-field horizontal label="Purpose" class="mb-5 align-items-center" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                  <b-radio class="mt-1" v-model="inputPurpose"
                      size=""
                      native-value="I would like to arrange an interview">
                      I would like to arrange an interview.
                  </b-radio>
                </b-field>
                <b-field horizontal  class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                  <b-radio v-model="inputPurpose"
                      class="know-more"
                      size=""
                      native-value="I would like to know more about AHAM Wealth Partners">
                      I would like to know more about AHAM Capital Wealth Partners.
                  </b-radio>
                </b-field>
                <b-field horizontal class="mb-5" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                  <b-radio v-model="inputPurpose"
                      size=""
                      native-value="Others">
                      Others
                  </b-radio>
                </b-field>
              </validation-provider>
            </div>

            <div class="message-field pt-3">
              <validation-provider :rules="{required: true}" v-slot="{ errors }">
                <b-field horizontal label="Message" custom-class="is-medium" :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                    <b-input maxlength="200" rows="3" v-model="inputMessage" type="textarea" placeholder="Enter your Message"></b-input>
                </b-field>
              </validation-provider>
            </div>
            
            <div class="captcha-wrapper">
              <VueRecaptcha
                ref="recaptcha"
                :sitekey=sitekey
                :load-recaptcha-script="true"
                @verify="handleSuccess"
                @error="handleError"
                @expired="handleExpired"
                class="captcha-contact" 
              ></VueRecaptcha>
              <b-button type=" submit" class="button dark-red" @click="handleSubmit(onSubmit(invalid))" icon-right="play" :disabled="invalid || !isVerify">Submit Inquiry </b-button>
            </div>
          </validation-observer>
        </div>
      </div>
      <div class="is-flex is-justify-content-end">
        <ScrollTop />
      </div>
    </div>
  </div>
</template>

<script>
import ScrollTop from '../components/ScrollTop.vue';
import { defineComponent } from 'vue';
import { VueRecaptcha } from 'vue-recaptcha';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import "@/pages/vee-validate.js";

  export default defineComponent({
    components: { ScrollTop, ValidationProvider, ValidationObserver, VueRecaptcha },
    data(){
      return{
        inputFullName: '',
        inputEmail: '',
        inputPhoneNo: '',
        inputRegion: '',
        inputPurpose: '',
        inputMessage: '',
        isVerify: false,
        region: [
          {
            id: 0,
            value: "Petaling Jaya",
          }, 
          {
            id: 1,
            value: "Perak",
          },
          {
            id: 2,
            value: "Melaka",
          },
          {
            id: 3,
            value: "Johor",
          },
          {
            id: 4,
            value: "Sarawak - Kuching",
          },
          {
            id: 5,
            value: "Sarawak - Miri",
          },
          {
            id: 6,
            value: "Sabah - Kota Kinabalu",
          }
        ] 
      }
    },
    async mounted(){
      window.scrollTo(0, 0);
    },
    methods: {
      onSubmit(value) {
        if(value === false && this.isVerify === false){
          this.displayToast('Invalid Captcha', 'is-danger');
        }else if(value === false && this.isVerify === true){
          this.storeFormData();
        }
      },
      storeFormData(){
        this.$httpClientCMSPost.post("/api/entry-contact-uses", 
        {
          data: {
            fullname: this.inputFullName,
            email: this.inputEmail,
            phone_number: this.inputPhoneNo,
            message: this.inputMessage,
            region: this.inputRegion,
            purpose: this.inputPurpose
          }
        })
        .then(resp => {
          this.displayToast('Form submitted successfully', 'is-success');
          location.reload();
        })
        .catch((error) => {
          this.displayToast('Failed to submit form', 'is-danger');
        });
      },
      displayToast(message, type){
        this.$buefy.toast.open({
            message: message,
            type: type
        })
      },
      handleSuccess() {
        this.isVerify = true;
      },
      handleError() {
        alert('Server error!');
      },
      handleExpired() {
        this.$refs.recaptcha.reset();
      }
    },
    computed: {
      sitekey(){
        return process.env.VUE_APP_RECAPTCHA_SITE_KEY;
      }
    }
  });
</script>

<style scoped lang="scss">


.banner-section {
  background-position: left 20% center !important;
  background: url('../assets/img/banner/contactus-banner.jpg') center;
}


.section-top {
  background-color: #F3F3F3;
  padding: 5rem 0;

  .desc {
    margin: 1.5rem 1rem 0;
  }
}

.contact-column{
  padding: 4rem 90px 3.5rem;
}

.field {
  margin-bottom: 2rem !important;
}

.b-radio.radio {
  color: #363636;
}

.purpose {
  .field {
    margin-bottom: 1.5rem !important;
  }
}

.message-field {
  .field {
    margin-bottom: 0.5rem !important;
  }
}

.captcha-wrapper {
  max-width: 243px; 
  text-align: left; 
  margin-left: 19%;
}
.captcha-contact{
  transform:scale(0.8);
  -webkit-transform:scale(0.8);
  transform-origin:0 0;
  -webkit-transform-origin:0 0;
  margin-bottom: 2rem;
}

@media screen and (max-width: 1660px) {
  .section-top {
    background-color: #F3F3F3;
    padding: 4rem 0;

    .desc {
      margin: 1rem 1rem 0;
    }
  }
}

@media screen and (max-width:1290px) and (min-width: 1024px){
  .contact-column{
    padding-left: 45px !important;
    padding-right: 40px !important;
  }
}

@media screen and (max-width: 1023px) {
  .contact-column{
    padding-left: 10px !important;
    padding-right: 20px !important;
    padding-top: 2.5rem;
  }

  .section-top {
    padding: 2.5rem 0;
    .desc {
      margin: 0.5rem 1rem 0;
    }
  }
}

@media (min-width: 769px) and (max-width: 920px) {
  :deep() {
    .b-radio.radio.know-more {
      align-items: flex-start;
      .check {
        margin-top: 3px;
      }
    }
  }
}

@media (max-width: 575px) {
  :deep() {
    .b-radio.radio.know-more {
      align-items: flex-start;
      .check {
        margin-top: 3px;
      }
    }
  }
}

@media screen and (max-width: 768px) {

  .captcha-wrapper {
    margin-left: 0;
    .captcha-contact {
      margin: 2rem 0;
    }
    
  }

  .subtitle {
    font-weight: 400;
  }
  // .contact-column{
  //   margin-bottom: 180px !important;
  // }
}

@media screen and (min-width: 1661px) {
}

</style>
